/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import Terms from "../components/page-sections/terms/Terms";

/* Session Imports */

import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "../lib/session";

const TermsOfUse = ({ user }) => {
  return (
    <React.Fragment>
      <Layout
        title="Terms & Conditions | Sentient Developers"
        description="Read the official terms and conditions for using Sentient Developers’ website, services, and content. Stay informed and browse our policies before engaging."
        user={user}
      >
        <Terms />
      </Layout>
    </React.Fragment>
  );
};

export default TermsOfUse;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
